import CompareService from "../../services/compare.service";

const compareModule = {
    namespaced: true,
    state: {
        loading: false,
        checkout: null,
        isComparePage: false
    },
    getters: {
        count: (state) => state.checkout ? state.checkout.items.length : 0
    },
    actions: {
        async add({ state, dispatch, commit }, { chosen, id, type, chosenType }) {
            try {
                const result = await CompareService.add(chosen, id, type);
                chosen = chosen.replace(/\\/gi, '\\\\');
                let data = {};
                document.querySelectorAll(`[data-chosen="${chosen}"][data-id="${id}"][data-chosen-type="${chosenType}"]`).forEach((item) => {
                    item.dataset.compareSelected = result.data.key;
                    data = {
                        name: item.dataset.chosenName,
                        price: item.dataset.chosenPrice,
                        type: item.dataset.chosenType,
                    }
                });

                dispatch('fetchCheckout');
                dispatch('notification/showSuccessNotificationWithData', {text: 'Добавлено в сравнение', data}, {root:true});
            } catch (e) {
                dispatch('notifyError', e);
            }
        },
        async remove({ state, dispatch, commit, getters }, { key, chosenType }) {
            try {
                const result = await CompareService.remove(key);
                let data = {};
                document.querySelectorAll(`[data-compare-selected="${key}"][data-chosen-type="${chosenType}"]`).forEach((item) => {
                    item.dataset.compareSelected = '';
                    data = {
                        name: item.dataset.chosenName,
                        price: item.dataset.chosenPrice,
                        type: item.dataset.chosenType,
                    }
                });

                await dispatch('fetchCheckout');
                dispatch('notification/showErrorNotificationWithData', {text: 'Удалено из сравнения', data}, {root:true});

                // && !getters.count - при удалении нужен рефреш из-за слайдера и стики плашки
                // если рефрешить на каждое удаление говна идея, то надо думать, как рефрешить все те элементы
                if (state.isComparePage) {
                    window.location.reload();
                }
            } catch (e) {
                dispatch('notifyError', e);
            }
        },
        async loadCheckout({ state, dispatch, commit }) {
            if (!state.checkout && !state.loading) {
                commit('setLoading', true);
                await dispatch('fetchCheckout');
                if (document.querySelector('[data-compare-list]')) {
                    commit('setComparePage', true)
                }
                commit('setLoading', false);
            }
        },
        async fetchCheckout({ commit }) {
            try {
                const result = await CompareService.fetchCheckout();
                commit('setCheckout', result.data);
            } catch (e) {
                console.log(e);
            }
        },
        // setComparePage({commit}, isComparePage) {
        //     commit('setComparePage', isComparePage)
        // },
        // async initializationCompare ({ state, dispatch, commit }) {
        //     const response = await CompareService.updateCompareList();
        //     const page = document.createElement('div');
        //     page.innerHTML = response.data;
        //
        //     const newData = page.querySelector('[data-compare-list]');
        //     const currentData = document.querySelector('[data-compare-list]');
        //
        //     currentData.parentNode.replaceChild(newData, currentData);
        //
        //     let event = new Event('DOMContentMutated');
        //     document.dispatchEvent(event);
        // },
    },
    mutations: {
        setCheckout(state, data) {
            state.checkout = data;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setComparePage(state, isCompare) {
            state.isComparePage = isCompare;
        }
    },
};

export default compareModule;